import React, { useState, useRef, useEffect } from "react";
import useIsMounted from './useIsMounted';
import './notePad.css';
import { FaSave, FaTrash, FaChevronDown, FaChevronUp, FaCheck } from "react-icons/fa";

function NotePad({ defaultVisible, defaultContent }) {
    const textareaRef = useRef(null);
    const [noteContent, setNoteContent] = useState(defaultContent);
    const [showNotePad, setShowNotePad] = useState(defaultVisible);
    const [showCheckmark, setShowCheckmark] = useState(false);
    const saveTimeout = useRef(null);
    const typingTimeout = useRef(null);
    const [noAnimate, setNoAnimate] = useState(true);
    const isMounted = useIsMounted();


useEffect(() => {
  // Turn off suppressor after initial paint
  requestAnimationFrame(() => setNoAnimate(false));
}, []);
  
    useEffect(() => {
      setNoteContent(defaultContent);
      setShowNotePad(defaultVisible);
    }, [defaultContent, defaultVisible]);
  
    const handleSave = () => {
      const value = textareaRef.current.value;
      localStorage.setItem('troubleshootingNote', value);
      setNoteContent(value);
      triggerCheckmark();
    };
  
    const handleReset = () => {
      localStorage.removeItem('troubleshootingNote');
      setNoteContent('');
      if (textareaRef.current) textareaRef.current.value = '';
    };
  
    const toggleNotePad = () => {
      const nextState = !showNotePad;
      setShowNotePad(nextState);
      localStorage.setItem('notePadVisible', nextState);
    };
  
    const triggerCheckmark = () => {
      setShowCheckmark(true);
      clearTimeout(saveTimeout.current);
      saveTimeout.current = setTimeout(() => setShowCheckmark(false), 1000);
    };
  
    const handleTyping = (e) => {
      const value = e.target.value;
      clearTimeout(typingTimeout.current);
      typingTimeout.current = setTimeout(() => {
        localStorage.setItem('troubleshootingNote', value);
        setNoteContent(value);
        triggerCheckmark();
      }, 1000);
    };
  
    return (
      <div className="note-pad-container hide-on-mobile">
            <button
        className={`titleText note-pad-toggle-btn ${showNotePad ? 'bouncing-open' : 'bouncing-close'}`}
        onClick={toggleNotePad}
      >
          {showNotePad ? (
            <>
              <FaChevronUp style={{ marginRight: '6px' }} />
              Hide Notepad
            </>
          ) : (
            <>
              <FaChevronDown style={{ marginRight: '6px' }} />
              Show Notepad
            </>
          )}
        </button>
  
        <div
        className={`note-pad-body ${isMounted.current ? (showNotePad ? 'pop-open' : 'pop-close') : ''}`}
      >

          <textarea
            ref={textareaRef}
            className="note-pad-textarea"
            placeholder="Write troubleshooting notes here"
            defaultValue={noteContent}
            onInput={handleTyping}
          ></textarea>
  
          <div className="note-pad-action-icons-container">
            <span
              className={`note-pad-action-icons site-icons orng-hover ${showCheckmark ? 'check-active' : ''}`}
              onClick={handleSave}
              title="Save to browser storage"
            >
              {showCheckmark ? <FaCheck /> : <FaSave />}
            </span>
            <span
              className="note-pad-action-icons site-icons red-hover"
              onClick={handleReset}
              title="Clear and Reset"
            >
              <FaTrash />
            </span>
          </div>
        </div>
      </div>
    );
  }
  
  export default NotePad;
  

